export default "__VITE_ASSET__CABK2MCP__"